<template>
  <DefaultLayout>
    <ProductPageHeroBanner :productType="productType" />
    <DynamicProductPage :productType="productType" />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProductPageHeroBanner from '../components/products/ProductPageHeroBanner.vue';
import DynamicProductPage from './DynamicProductPage.vue';
import { useRoute } from 'vue-router';
import { ref } from 'vue';

export default {
  name: 'InsuranceProductPage',

  components: {
    DefaultLayout,
    ProductPageHeroBanner,
    DynamicProductPage,
  },

  setup() {
    const route = useRoute();
    const productType = ref(route.params.productType);

    console.log('Route parameter - productType:', productType.value);

    return { productType };
  },
};
</script>

<!-- Remove the style tag if it's not being used -->
